"use client";

import type { ReactElement, ReactNode } from "react";
import { cloneElement, isValidElement } from "react";
import { trackAnalyticsEvent } from "@/lib/analytics/track";

export function BlogCtaTracker({
  ctaType,
  contentName,
  children,
}: {
  ctaType: string;
  contentName: string;
  children: ReactNode;
}): ReactElement {
  if (!isValidElement(children)) {
    return <>{children}</>;
  }

  const child = children as ReactElement<{
    onClick?: (e: React.MouseEvent) => void;
  }>;

  return cloneElement(child, {
    onClick: (e: React.MouseEvent) => {
      trackAnalyticsEvent("blog_cta_click", {
        cta_type: ctaType,
        content_name: contentName,
      });
      child.props.onClick?.(e);
    },
  });
}
